import { AssetLoaderProvider } from "@getpresenta/renderer";
import { useEffect, useMemo, useRef, type ReactNode } from "react";
import { createRendererAssetLoader } from "utils/rendererAssetLoader";

/** Supplies authenticated image loading to all presentation and thumbnail renderers. */
export function RendererAssetProvider({ children }: { children: ReactNode }) {
  const loader = useMemo(() => createRendererAssetLoader(), []);
  const activeLoader = useRef<typeof loader | null>(null);
  useEffect(() => {
    activeLoader.current = loader;
    return () => {
      activeLoader.current = null;
      // StrictMode reconnects the same loader immediately after its cleanup probe.
      queueMicrotask(() => {
        if (activeLoader.current !== loader) loader.dispose();
      });
    };
  }, [loader]);
  return <AssetLoaderProvider loader={loader}>{children}</AssetLoaderProvider>;
}
